module.exports = __webpack_public_path__ + "img/owners-login.d5a1f589.jpg";